const servicios = 'certificador.hexasolutions.co';
const protocolo = 'https';
const webSocket = 'wss';

export const environment = {
  production: false,
  nameEnviroment: 'Dev',
  endpoint: `${protocolo}://analizamosback.${servicios}`,
  endpointreportes: `${protocolo}://analizamosback.${servicios}`,
  notificador: `${protocolo}://notificador.${servicios}`,
  notificadorStomp: `${webSocket}://ws.${servicios}`,
  domainAuthorization: `${servicios}`,
  dobleAutenticacion: `${protocolo}://${servicios}:3333`,
  google_auth_client_id: '643245577998-npnm8bj3onq0mg6kvcki0silf1b34bb9.apps.googleusercontent.com',
  google_auth_client_secret: 'MD8Ikj8gNGXmcLZX0dHTo-eX',
  google_maps_key: 'AIzaSyDEnyBopZvRkonk5iMNV-vg1uihu9ARlEQ',
  google_analytics_id: 'UA-177939367-2',
  tiempoInactividad: 900,
  unica_session_usuario: false,
  url_credito_digital: `${protocolo}://digital.${servicios}`,
  servidor_catpura_ip_privada: 'https://capturaip.hexasolutions.co:3001',
  servidor_catpura_ip: 'https://capturaip.crezcamos.local:3001',
  // Configuración conexión Facetec
  facetecKey: 'd2mqkSIyJEtasi8svxYSCH6qsLXef3yx',
  facetecURL: 'https://facetec.aseguramossoporte.hexasolutions.co',
  facetecPublicKey: '-----BEGIN PUBLIC KEY-----\n' +
    'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA5PxZ3DLj+zP6T6HFgzzk\n' +
    'M77LdzP3fojBoLasw7EfzvLMnJNUlyRb5m8e5QyyJxI+wRjsALHvFgLzGwxM8ehz\n' +
    'DqqBZed+f4w33GgQXFZOS4AOvyPbALgCYoLehigLAbbCNTkeY5RDcmmSI/sbp+s6\n' +
    'mAiAKKvCdIqe17bltZ/rfEoL3gPKEfLXeN549LTj3XBp0hvG4loQ6eC1E1tRzSkf\n' +
    'GJD4GIVvR+j12gXAaftj3ahfYxioBH7F7HQxzmWkwDyn3bqU54eaiB7f0ftsPpWM\n' +
    'ceUaqkL2DZUvgN0efEJjnWy5y1/Gkq5GGWCROI9XG/SwXJ30BbVUehTbVcD70+ZF\n' +
    '8QIDAQAB\n' +
    '-----END PUBLIC KEY-----',
  facetecKeyProduccion: {
    domains: 'crezcamos.com,192.168.150.22,hexasolutions.co,probamos.co',
    expiryDate: '2024-10-10',
    key: '00304502205d1c29e65f9bd7ed4bf43fcab0b87eb18ac56a8d79682d6e9d909ac70448a156022100cc2a4cd5b82a0e5c1fa463e36788ea18346564d7be7f6aa70178fe9d62ddda9a'
  },
  clarityId: '',
  rollbaraAccessToken: '855c1a08e87a404baa66256096cc46f1',
  urlOAuthGenesys: 'https://getip.hexasolutions.co:4000'
};
